import React, { useEffect } from 'react';
import './ArticleNavButtons.css';

const ArticleNavButtons = ({ articleRef, commentsRef }) => {
  useEffect(() => {
    // Keep buttons visible all the time on article pages
    return () => {};
  }, []);

  const handleScrollTo = (target) => {
    if (target === 'top') {
      articleRef?.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (target === 'end') {
      const footer = articleRef?.current?.querySelector('.comments-header');
      // Align footer to the bottom of the viewport so it appears at page bottom
      footer?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    } else if (target === 'bottom') {
      // Scroll to absolute bottom of page
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  };

  return (
    <div className="article-nav-buttons">
      <button
        className="nav-btn nav-top"
        onClick={() => handleScrollTo('top')}
        title="Scroll to top"
        aria-label="Go to top"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="18 15 12 9 6 15" />
        </svg>
        <span>Top</span>
      </button>

      <button
        className="nav-btn nav-end"
        onClick={() => handleScrollTo('end')}
        title="Scroll to end of article"
        aria-label="Go to end of article"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
        <span>Comments</span>
      </button>

      <button
        className="nav-btn nav-bottom"
        onClick={() => handleScrollTo('bottom')}
        title="Scroll to bottom (comments)"
        aria-label="Go to bottom"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="18 9 12 15 6 9" />
        </svg>
        <span>Bottom</span>
      </button>
    </div>
  );
};

export default ArticleNavButtons;
